import React from "react";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Renders the children only when the condition (`props.if`) is met/truthy.
 *
 * @param props.if When truthy, renders the children.
 * @param props.else An alternative component that's rendered when `props.if` isn't truthy.
 */
function Render(_ref) {
  var _if = _ref.if,
    _else = _ref.else,
    children = _ref.children;
  if (_if) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: children
    });
  }
  return _else ? /*#__PURE__*/_jsx(_Fragment, {
    children: _else
  }) : null;
}
export default Render;
//# sourceMappingURL=Render.js.map